import { cn, tv } from "@utils/tw"
import { PropsWithChildren, ReactNode } from "react"

type Props = PropsWithChildren<{
  className?: string
}>

export function Chip(props: Props) {
  return (
    <div
      className={cn(
        "bg-black/40 type-label-s border border-white/60 px-2 py-1 text-nowrap",
        "[a:hover_&]:bg-white/10",
        props.className,
      )}
    >
      {props.children}
    </div>
  )
}
